import { memo } from 'react';
import { convertAmount, getAmountWithCurrency, toFixed, useTranslation } from '@pascal/pascal-core';
import { observer } from 'mobx-react-lite';
import { doBetStore } from '../../../store/doBetStore';

const WinningComp = observer(() => {
  const { winAmount } = doBetStore;
  const t = useTranslation();

  return (
    <div className={`popup-game-win ${winAmount ? '' : 'd-none'}`}>
      <div className='popup-game-win-content'>
        <p className='popup-game-win-text'>{t('YOU_WIN')}</p>
        <p className='popup-game-win-money'>
          {getAmountWithCurrency({ amount: convertAmount(toFixed(Number(winAmount))) })}
        </p>
      </div>
    </div>
  );
});

WinningComp.displayName = 'Winning';

export const Winning = memo(WinningComp);
